import { Link } from "react-router-dom";
import logo from "../../Elements/Images/logo.png";
import LoginForm from "./Components/LoginForm";
import { publicUrls } from "../../Api/Auth/AppUrls";

const Login = () => {
  return (
    <div className="flex min-h-screen flex-col md:flex-row">
      {/* Left Section (Form) */}
      <div className="w-full md:w-1/2 flex items-center justify-center bg-white">
        <div className="flex items-center justify-center w-full h-screen px-4">
          <div className="bg-white p-8 rounded-lg shadow-[0_0_10px_3px_rgba(0,0,0,0.15)] w-full max-w-md sm:max-w-lg">
            {/* Logo */}
            <Link to={publicUrls.Home}>
              <div className="flex justify-center mb-6">
                <img src={logo} alt="Logo" className="h-12 w-auto" />
              </div>
            </Link>
            <LoginForm />
          </div>
        </div>
      </div>

      {/* Right Section (Image) */}
      <div
        className="hidden md:block md:w-2/3 bg-contain bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://storage.googleapis.com/road-to-fe/uploads/1763568550643-fa585285-03aa-4479-af51-9f4cc762167e-login%20page%20person-01.webp)",
        }}
      >
        {/* This div will act as the background image container */}
      </div>
    </div>
  );
};

export default Login;
